import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ModuleUser } from './module-user.model';

export class ModuleUserStateModel extends EntityStateModel<ModuleUser> {}
